import React from "react";
import SEO from "../common/SEO";

import FooterTwo from "../common/footer/FooterTwo";
import Copyright from "../common/footer/Copyright";
import AboutOne from "../elements/about/AboutOne";
import SectionTitle from "../elements/sectionTitle/SectionTitle";

import HeaderOne from "../common/header/HeaderOne";
import AboutSix from "../elements/about/AboutSix";

import CounterUpFour from "../elements/counterup/CounterUpFour";

import AboutFive from "../elements/about/AboutFive";
import AboutFour from "../elements/about/AboutFour";
import ServiceThree from "../elements/service/ServiceThree";
import TimelineTwo from "../elements/timeline/TimelineTwo";
import TestimonialTwo from "../elements/testimonial/TestimonialTwo";
import { FiCheck } from "react-icons/fi";
import Separator from "../elements/separator/Separator";

const BusinessConsulting2 = () => {
  return (
    <>
      <SEO title="Metodo Panini" />
      <main className="page-wrapper">
        <HeaderOne
          btnStyle="btn-small round btn-icon"
          HeaderSTyle="header-transparent"
        />

        <AboutSix />
        <div className="rwt-counterup-area rn-section-gap ">
          <div className="container">
            <CounterUpFour
              column="col-lg-3 col-md-6 col-sm-6 col-6"
              counterStyle="counter-style-4"
              textALign="text-center"
            />
          </div>
        </div>

        <div>
          <AboutOne />
        </div>
      
        {/* <TestimonialThree/> */}
        <div className="main-content" id="servicios">
          <div className="rwt-gallery-area rn-section-gap rn-color">
          <hr className="linea-con-efecto"/>
            <div className="container">
              <div className="row">
                <div className="col-lg-12 mb--20">
                  <SectionTitle
                    textAlign="text-center"
                    subtitle="Nuestros Servicios"
                    title="Nuestro método"
                  />
                </div>
                <div className="content text-center">
                  <h6 className="p3" style={{ marginTop: "-2rem" }}>
                    * Podes optar por un solo método, pero los 3 métodos juntos
                    son la magia que buscas.
                  </h6>
                </div>
              </div>

              <ServiceThree
                serviceStyle="service__style--2"
                textAlign="text-center"
              />
            </div>
          </div>
          <div
            className="rn-callto-action clltoaction-style-default bg_image bg_image_fixed"
            style={{
              backgroundImage: `url(${process.env.PUBLIC_URL}/dare/reunion-negocios-cafe.jpg)`,
            }}
            data-black-overlay="7"
            id="busquedapersonal"
          >
            <div className="container text-center">
              <div className="row">
                <div className="col-lg-12">
                  <SectionTitle
                    textAlign="text-center"
                    radiusRounded=""
                    subtitle="Método 1"
                    title="Búsqueda de Staff Gastronómico."
                  />
                </div>
              </div>
              <div className="content text-center">
                <ul className="list-icon">
                  <li className="p3-white">
                    Nos especializamos en la búsqueda de mandos medios:
                  </li>
                  <li className="p3-white">Para cocina:</li>
                  <li className="p3-white">
                    <span className="icon-check">
                      <FiCheck />
                    </span>
                    Sub-chef y segundos a cargo.
                  </li>
                  <li className="p3-white">
                    <span className="icon-check">
                      <FiCheck />
                    </span>
                    Chef de partida y responsables de cocina.
                  </li>
                  <li className="p3-white">
                    <span className="icon-check">
                      <FiCheck />
                    </span>
                    Chef Ejecutivo.
                  </li>
                    <li className="p3-white">Para salón o conducción general:</li>
                  <li className="p3-white">
                    <span className="icon-check">
                      <FiCheck />
                    </span>
                    	Cajeros, Encargados de local, Gerentes de local y Directores de AA&BB.
                  </li>
                  <li className="p3-white">
                    <span className="icon-check">
                      <FiCheck />
                    </span>
                    Supervisores de franquicias, Gerente de Operaciones, Gerente General.
                  </li>
                  <li className="p3-white">

                    
                  </li>
                  {/* <li className="p3-white">
                  Buscamos equipos completos solo en aperturas de locales nuevos (camareros, etc).
                  </li> */}
                </ul>
              </div>
              <div className="row">
                <div className="col-lg-10 offset-lg-1 mt--50">
                  <TimelineTwo classVar="no-gradient" />
                </div>
              </div>
            </div>
          </div>
          <div className="rwt-elements-area rn-section-gap bg-color-white">
            <div className="container">
              <TestimonialTwo column="col-lg-12" teamStyle="" />
            </div>
          </div>
          <div id="Gastromentorias">
            <AboutFour />
          </div>
          <div id="mystery">
            <AboutFive />
          </div>
        </div>

        <FooterTwo />
        <Copyright />
      </main>
    </>
  );
};
export default BusinessConsulting2;
